export const heavyManufacturingData = {
  themeColor: "#DA291C",

  breadcrumbs: [
    {
      text: "HOME",
      url: "/"
    },
    {
      text: "FOR PROS",
      url: null
    },
    {
      text: "INDUSTRIAL SOLUTIONS",
      url: "/industrial"
    },
    {
      text: "HEAVY MANUFACTURING",
      url: null
    }
  ],

  heroCTAs: {
    topButton: {
      text: "REQUEST SAMPLES",
      url: "/industrial/samplesrequest/"
    },
    mainButtons: [
      {
        text: "ASK A TECHNICAL SPECIALIST",
        url: "/industrial/technicalspecialist/",
        variant: "outline"
      },
      {
        text: "REQUEST A SITE ASSESSMENT",
        url: "#site-assessment-form",
        variant: "red"
      }
    ]
  },

  components: [ 
    {
      component: "cardDeck",
      variant: "vertical",
      id: "product-lines",
      eyebrow: "you Know the wd-40® brand name —",
      title: "but do you know what it can do for your heavy manufacturing operation?",
      body: "For over 70 years, WD-40 Brand has helped industrial teams tackle tough jobs—maintaining hydraulics, protecting equipment, and fighting corrosion. WD-40 Specialist® supports every stage of manufacturing with solutions that reduce wear, cut downtime, and protect key assets. With smart delivery and proven performance, it helps teams get the Job Done Right®.",
      cards: [
        {
          id: "clean-degrease",
          image: "/img/industrial-page/new/heavy-manufacturing/Inustrial Solutions - Degreaser Image 2.png",
          title: "CLEANERS & DEGREASERS",
          description: "Remove grease, grime, and contaminants fast",
          linkUrl: "/products/?functionality=clean-degrease"
        },
        {
          id: "lube-penetrants",
          image: "/img/industrial-page/new/heavy-manufacturing/Heavy Manufacturing_lube & pen Image 1.png",
          title: "LUBRICANTS & PENETRANTS",
          description: "Free stuck parts and reduce friction",
          linkUrl: "/products/?functionality=lubricates%2Cpenetrate-loosen"
        },
        {
          id: "rust-solutions",
          image: "/img/industrial-page/new/Industrial Solutions - Rust Solutions Image.png",
          title: "RUST SOLUTIONS",
          description: "Stop rust and protect metal surfaces",
          linkUrl: "/products/?functionality=removes%2Clubricates%2Crestores%2Cprotects%2Cpenetrate-loosen%2Cclean-degrease"
        }
      ],
      ctaText: "BROWSE ALL INDUSTRIAL PRODUCTS",
      ctaUrl: "/products/?category=specialist"
    },
    
    {
      component: "cardDeck",
      variant: "icons",
      id: "facility-applications",
      title: "FACILITY APPLICATIONS",
      cards: [
        {
          id: "cnc-machining-zones",
          image: "/img/industrial-page/new/heavy-manufacturing/CNC Icon 1.png",
          title: "CNC Machining Zones",
          subtitle: "Keep machines running, not rusting.",
          description: 'Use <a href="/products/industrial_strength_degreaser/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Industrial-Strength Degreaser</a> to cut through tough coolant buildup and metal shavings. Follow with <a href="/products/white-lithium-grease/" target="_blank" rel="noopener noreferrer">White Lithium Grease</a> to lubricate way covers and moving parts—reducing jams and unplanned downtime. For electrical panels and sensors, <a href="/products/contact-cleaner/" target="_blank" rel="noopener noreferrer">Contact Cleaner</a> ensures safe, residue-free performance.'
        },
        {
          id: "welding-fabrication-zones",
          image: "/img/industrial-page/new/heavy-manufacturing/Welding Icon 1.png",
          title: "Welding & Fabrication Zones",
          subtitle: "Beat buildup and seize-ups.",
          description: '<a href="/products/silicone-lubricant/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Silicone Lubricant</a> keeps jigs, clamps, and guides moving freely with a clear, water-resistant formula ideal for metal, plastic, and rubber surfaces. For frozen fasteners and corroded threads, <a href="/products/penetrating-oil/" target="_blank" rel="noopener noreferrer">Penetrant</a> delivers fast breakaway power. Use <a href="/products/dry-lube/" target="_blank" rel="noopener noreferrer">Dry Lube</a> on metal chutes and slides where traditional oils attract too much debris.'
        },
        {
          id: "maintenance-tool-cribs",
          image: "/img/industrial-page/new/heavy-manufacturing/Maintenance Icon 1.png",
          title: "Maintenance & Tool Cribs",
          subtitle: "Prep, protect, and power through repairs.",
          description: '<a href="/products/industrial-strength-cleaner-degreaser-32oz/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Cleaner & Degreaser</a> tackles grease and grime on tools, motors, and chains before servicing. Keep shop equipment running smoothly with a variety of <a href="/products/?category=specialist" target="_blank" rel="noopener noreferrer">WD-40 Specialist Lubricants and Penetrants</a>, and use Contact Cleaner for safe upkeep of power tools and control panels.'
        }
      ]
    },

    {
      component: "fullWidthCTA",
      id: "facility-map",
      title: "solutions to every area of your facility",
      buttons: [
        {
          text: "download facility map",
          url: "https://www.datocms-assets.com/10845/1725637043-facility-full-of-uses.pdf",
          isSecondary: false
        }
      ]
    },


    {
      component: "cardDeck",
      variant: "badges",
      id: "badges-card-deck",
      title: "Introducing<br>the WD-40 Brand<br>Job Done Right® System",
      subtitle: "Experience a comprehensive solution designed to protect your equipment at every stage.",
      body: "This end-to-end approach ensures optimal performance, reduces the risk of failures, and keeps your machinery running smoothly.",
      extraImages: [
        "/img/industrial-page/new/WD40 - PCLP Graphic_v3 1.png",
        "/img/industrial-page/new/WD-40 Specialist Line 2.png"
      ],
      cards: [
        {
          id: "prep-it",
          image: "/img/industrial-page/new/Industrial Solutions - Prep It - Image.png",
          title: "Prep It",
          description: "Start every job with thorough preparation"
        },
        {
          id: "clean-it",
          image: "/img/industrial-page/new/Industrial Solutions - Clean It - Image.png",
          title: "Clean It",
          description: "Clean your surface for optimal lubrication"
        },
        {
          id: "lube-it",
          image: "/img/industrial-page/new/Industrial Solutions - Lube It - Image.png",
          title: "Lube It",
          description: "Experience superior performance with the best lubrication products on the market"
        },
        {
          id: "protect-it",
          image: "/img/industrial-page/new/Industrial Solutions - Protect It - Image.png",
          title: "Protect It",
          description: "Safeguard your hard work with the trusted protection of the WD-40 Brand"
        }
      ]
    },

    {
      component: "cardDeck",
      variant: "products"
    },

    {
      component: "fullWidthCTA",
      id: "safety-efficiency",
      title: "SOLUTIONS TO MAXIMIZE SAFETY & EFFICIENCY",
      buttons: [
        {
          text: "SAFETY DATA SHEETS",
          url: "https://wd40company.com/partners-suppliers/safety-data-sheets/?region=USA",
          isSecondary: true
        },
        {
          text: "REQUEST SAMPLES",
          url: "/industrial/samplesrequest/",
          isSecondary: false
        }
      ]
    },
    {
      component: "NumberedStepsList",
      id: "trial-program",
      eyebrow: "PREP IT. CLEAN IT. LUBE IT. PROTECT IT.",
      title: "WD-40 BRAND JOB DONE RIGHT TRIAL PROGRAM",
      subtitle: "GET INDUSTRIAL-STRENGTH PERFORMANCE, PROVEN IN YOUR FACILITY.",
      body: "The WD-40 Specialist product line is built to handle the toughest maintenance challenges across industries. Now, with our Job Done Right Trial Program, you can put our solutions to the test—right on your floor, with your team, and your toughest jobs.",
      steps: [
        {
          number: "1",
          title: "ON-SITE ASSESSMENT",
          description: "Our experts visit your facility to understand your systems, challenges, and performance goals. From conveyor lines to electrical panels, we evaluate where you need support most."
        },
        {
          number: "2",
          title: "TAILORED RECOMMENDATIONS BY PRODUCT CATEGORY",
          description: "We match WD-40 Specialist solutions to your specific needs:",
          bulletPoints: [
            {
              title: "Cleaners & Degreasers",
              description: "Remove grease, grime, and contaminants fast"
            },
            {
              title: "Lubricants & Penetrants",
              description: "Free stuck parts and reduce friction"
            },
            {
              title: "Rust Solutions",
              description: "Stop rust and protect metal surfaces"
            }
          ]
        },
        {
          number: "3",
          title: "TRIAL IMPLEMENTATION",
          description: "We'll run a live trial in your environment to demonstrate product performance where it matters most—on the job. You'll receive a detailed Findings Report with key metrics, ROI, and measurable improvements."
        },
        {
          number: "4",
          title: "LONG-TERM OPTIMIZATION",
          description: "The trial is just the beginning. Our team supports your ongoing success with training, product guidance, and evolving solutions as your facility grows."
        }
      ]
    },
    {
      component: "site-assessment-form"
    },
    {
      component: "cardDeck",
      variant: 'faqs',
      id: "food-beverage-faqs",
      title: "FREQUENTLY ASKED QUESTIONS",
      cards: [
        {
          id: "faq-1",
          title: "How do WD-40® Brand products help reduce equipment wear and unplanned downtime?",
          body: "WD-40 Brand solutions are engineered to perform in high-load, high-heat environments. Whether you’re lubricating slideways, protecting raw steel, or breaking loose seized fasteners, our products help extend the life of components and reduce the risk of costly shutdowns. Fewer failures mean more uptime—and more productivity."
        },
        {
          id: "faq-2",
          title: "Are WD-40® Brand solutions compatible with the metals, plastics, and systems used in manufacturing equipment?",
          body: "Yes. WD-40 Brand products are formulated for use on many materials commonly found in manufacturing environments—such as stainless steel, aluminum, copper, rubber, and a variety of plastics. As with any product, we recommend testing on a small, inconspicuous area or consulting equipment specifications before full application."
        },
        {
          id: "faq-3",
          title: "What safety and regulatory standards do WD-40® Brand products meet for use on the shop floor?",
          body: "All WD-40 Brand products are 50-state VOC compliant and require no California Prop 65 warning. They’re safe for indoor use, supported by GHS-compliant labels, and designed to meet the safety expectations of modern industrial environments. That means fewer compliance concerns and a cleaner audit trail."
        }
      ],
      ctaText: "ASK A TECHNICAL SPECIALIST",
      ctaUrl: "/industrial/technicalspecialist/"
    }
  ],

};
